import { PresentationType } from '~/converters/presentation-type';
import { CodeAndDescription } from '~/models/code-and-description';
import { DataType } from '~/models/data-type';
import { FieldValidationList } from './field-validation';

export type FieldModelMap<T extends string = string> = {
	[key in Extract<T, string>]: FieldModel;
};

export interface FormModel<T extends string = string> {
	isDirty?: boolean;
	fields: FieldModelMap<T>;
	warningMessages?: string[];
	formModelList?: FormModel[];
}

export function isFormModel(object: any): object is FormModel {
	return 'fields' in object;
}

/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.api.FieldModel
 * Do not change properties and keep them synchronized with backend class
 */
export interface FieldModelBackend {
	codeType?: CodeType;
	codeAndDescriptionKey?: string;
	codeList?: CodeAndDescription[];
	dataType?: DataType;
	endField?: boolean;
	fieldDescription?: string;
	fieldValidationList?: FieldValidationList;
	fixedCodeAndDescriptionKey?: boolean;
	inputMask?: string;
	label?: string;
	length?: number;
	modifiable?: Modifiable;
	modifiedByEvent?: boolean;
	readonly name: string;
	required?: boolean;
	visible?: boolean;
	presentationType?: PresentationType;
}

/**
 * Extension of FieldModelBackend so that we can add more properties in the frontend without needing to synchronise with backend class
 * @member {boolean} forceSave set to true to ensure field is included in save even if Modifiable.FALSE
 */
export interface FieldModel extends FieldModelBackend {
	anchorHref?: string;
	excludeFromSave?: boolean;
	forceSave?: boolean;
	value?: string;
	// Relevant to search field only.
	displayResultsOnFocus?: boolean;
}

export enum Modifiable {
	FALSE = 'FALSE',
	TRUE = 'TRUE',
	INSERT_ONLY = 'INSERT_ONLY',
	UNKNOWN = 'UNKNOWN',
}

/**
 * This should correspond to the Java enum au.com.finsyn.acuritywebserver.core.forms.generic.CodesTypeEnum
 * Do not change properties and keep them synchronized with backend class.
 */
export enum CodeType {
	UCodes = 'UCodes',
	Codes = 'Codes',
}
